<template>
   <div>
      <section-definition :title="page.title" v-if="!isEditMode"></section-definition>


      <my-show-error
          v-model="dialog_show_error"
          :error="show_error_obj"
      ></my-show-error>


      <v-dialog v-model="show_cant_edit" max-width="600" persistent>
         <v-card class="pa-3 red--text" style="font-size: 13pt">
            <div>
               This grade cannot be edited due to the following issues:
            </div>


            <div class="mt-3" style="font-size: 12pt">
               {{ edit_error_msg }}
            </div>

            <div style="display:flex">
               <v-spacer/>
               <v-btn @click="$emit('close')" color="primary"
               >close
               </v-btn>

            </div>
         </v-card>
      </v-dialog>


      <v-dialog :value="edit_warning_msg!=null" max-width="600" persistent>
         <v-card class="pa-3 red--text" style="font-size: 13pt">
            <div>
               Warning
            </div>


            <div class="mt-3" style="font-size: 12pt">
               {{ edit_warning_msg }}
            </div>

            <div style="display:flex">
               <v-spacer/>
               <v-btn @click="edit_warning_msg=null" color="primary"
               >close
               </v-btn>

            </div>
         </v-card>
      </v-dialog>

      <v-dialog
          v-model="show_delete_file"
          max-width="420"
          persistent
      >
         <v-card>
            <v-card-title class="headline">Confirm Delete File?</v-card-title>

            <v-card-text>
               Are you sure you want to delete this file?
            </v-card-text>

            <v-card-actions>
               <v-btn color="red" text @click="delete_file()">Delete</v-btn>
               <v-spacer></v-spacer>
               <v-btn text @click="show_delete_file=false; file_to_del=null">Cancel</v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>


      <v-container>
         <v-stepper v-model="stepper_step" vertical>

            <!------------------------------------------step 1------------------------------------------------------------->
            <v-stepper-step step="1" :editable="isEditMode">
               <span v-if="form.sales_people[0].name === ''">Select ISM to Grade</span>
               <span v-else>Selected ISM: {{ form.sales_people[0].name }}</span>
            </v-stepper-step>

            <v-stepper-content step="1">
               <v-card>
                  <!--<v-card-title class="myheader" color="primary">Select ISM to Grade   </v-card-title>-->
                  <!--<v-card-text>-->
                  <v-form ref="form_1">
                     <v-container fluid grid-list-md page>
                        <v-layout wrap>
                           <v-flex xs12 sm8>
                              <v-autocomplete
                                  label="Organization/Dealership*"
                                  :items="dealerships"
                                  item-value="_id"
                                  item-text="txt"
                                  v-model="selected_dealer_id"
                                  v-on:change="on_select_dealership"
                                  :rules="[x=>isRequired(x, 'Dealership')]"
                                  :disabled="isEditMode"
                              >
                              </v-autocomplete>
                           </v-flex>

                           <v-flex grow></v-flex>

                           <v-flex xs12 sm12 md12>
                              <template v-for="(value, i) in form.sales_people">
                                 <v-layout :key="i">
                                    <v-flex md6 class="myforminput">
                                       <v-autocomplete
                                           :label="'Sales Person '+(i+1) +' Name'+(i===0 ? '*':'')"
                                           :items="salesPeople"
                                           item-value="user_id"
                                           item-text="name"
                                           v-model="form.sales_people[i].user_id"
                                           v-on:change="on_user_change(i)"
                                           :rules="[x=>isRequired(x, 'Sales Person')]"
                                           :disabled="isEditMode"
                                       >
                                       </v-autocomplete>
                                    </v-flex>
                                    <v-flex md6 class="myforminput">
                                       <v-text-field
                                           v-model="form.sales_people[i].email"
                                           :label="'Sales Person '+(i+1) +' Email'+(i===0 ? '*':'')"
                                           append-outer-icon="clear"
                                           @click:append-outer="form.sales_people.splice(i, 1)"
                                           :rules="[x=>isRequired(x, 'Sales Person'), checkEmail]"
                                           :disabled="isEditMode"
                                       ></v-text-field>
                                    </v-flex>
                                 </v-layout>
                              </template>
                           </v-flex>

                           <v-layout>
                              <v-flex class="myforminput" grow></v-flex>
                              <v-flex class="myforminput" shrink v-if="!isEditMode">

                                 Are there Additional ISM for this lead?
                                 <v-icon
                                     v-on:click="form.sales_people.push({user_id:'', name: '', email:''})"
                                 >add
                                 </v-icon>
                              </v-flex>

                           </v-layout>


                           <v-flex xs12 v-if="selectedDealership !==null">

                              <v-expansion-panel class="mt-3">
                                 <v-expansion-panel-content>
                                    <template v-slot:header>
                                       <div>See CRM Info</div>
                                    </template>

                                    <v-card class="pl-2 pr-2">
                                       <v-card-text>
                                          <v-layout wrap>
                                             <v-flex xs6 sm6>
                                                <v-text-field
                                                    label="CRM URL"
                                                    v-model="selectedDealership.info_crm.url"
                                                ></v-text-field>
                                             </v-flex>

                                             <v-flex xs6 sm3>
                                                <v-text-field
                                                    label="Username"
                                                    hint="User name for CRM"
                                                    v-model="selectedDealership.info_crm.username"
                                                ></v-text-field>
                                             </v-flex>

                                             <v-flex xs6 sm3>
                                                <v-text-field
                                                    label="Password"
                                                    :type="showpass ? 'text' : 'password'"
                                                    :append-icon="showpass ? 'visibility' : 'visibility_off'"
                                                    counter
                                                    @click:append="showpass = !showpass"
                                                    v-model="selectedDealership.info_crm.password"
                                                ></v-text-field>
                                             </v-flex>

                                          </v-layout>

                                       </v-card-text>

                                    </v-card>

                                 </v-expansion-panel-content>
                              </v-expansion-panel>

                           </v-flex>


                        </v-layout>
                     </v-container>
                  </v-form>
               </v-card>

               <v-layout row v-if="form_error_1">
                  <v-spacer></v-spacer>
                  <v-flex shrink class="pr-3 red--text"> {{ form_error_1 }}</v-flex>
               </v-layout>


               <v-layout v-if="!isEditMode">
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="stepper_1">Continue</v-btn>
               </v-layout>
            </v-stepper-content>


            <!------------------------------------------step 2------------------------------------------------------------->
            <v-stepper-step step="2" :editable="isEditMode">Fill Lead Info</v-stepper-step>
            <v-stepper-content step="2">
               <v-card>
                  <v-form ref="form_2">

                     <!--------------lead handling-------------------------------------------------------------------------------->
                     <form-lead-info
                         :form="form"
                         :selected-dealership="selectedDealership"

                     />




                     <v-layout md12 v-if="msg_duplicate_warning" class="pb-0" wrap>
                        <v-flex xs12 shrink class="red--text">Warning, this might be a duplicate lead. Here are the
                           previously
                           graded lead(s) that look similar:
                        </v-flex>
                        <v-flex xs12
                                class="pb-2"
                                v-for="(val, i) in lead_duplicates" :key="i"
                        >
                           Customer Name: {{ val.info_customer.name_first }} {{ val.info_customer.name_last }};
                           Vehicle: {{ val.info_lead.wanted_vehicle }};
                           Lead Source: {{ val.info_lead.lead_source }};
                           Date In: {{ val.info_lead.lead_arrived_date }}
                        </v-flex>
                     </v-layout>

                     <!--------------main grading form----------------------------------------------------------------------------->

                     <form-curriculum
                         ref="form_curriculum"
                         :curriculum="curriculum"
                         :form="form"
                         :grade_score.sync="grade_score"
                         :grade_letter.sync = "grade_letter"
                     />


                     <!--------------comment section----------------------------------------------------------------------------->
                     <v-layout wrap>
                        <v-flex xs12>
                           <span class="myheader"> Comments</span>
                           <v-divider></v-divider>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                           <v-textarea
                               label="Internal Comments"
                               v-model="form.comments_internal"
                               outline
                               auto-grow
                           >
                           </v-textarea>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                           <v-textarea
                               label="External Comments (Seen in Emails)"
                               auto-grow
                               outline
                               v-model="form.comments_external"
                               :rules="[x=> !!x || 'Please provides comments']"
                               @focus="on_first_comment_activate"
                           >
                           </v-textarea>
                        </v-flex>

                     </v-layout>
                  </v-form>

               </v-card>

               <v-layout md12 v-if="form_error_2" class="pb-0">
                  <v-flex grow></v-flex>
                  <v-flex shrink class="red--text">{{ form_error_2 }}</v-flex>
               </v-layout>

               <v-layout v-if="!isEditMode">
                  <v-btn color="primary" @click="stepper_step = 1">Go Back</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" :loading="submit_save_form" @click="save_form">Continue</v-btn>
               </v-layout>


               <!-- edit buttons -->
               <v-layout v-else>
                  <v-spacer/>


                  <v-btn color="primary" :loading="submit_save_form" @click="save_form">Save Changes</v-btn>


                  <v-spacer/>
               </v-layout>

            </v-stepper-content>


            <!------------------------------------------step 3 file uploads------------------------------------------------>
            <v-stepper-step step="3" :editable="isEditMode">Add Supporting Docs/Links</v-stepper-step>
            <v-stepper-content step="3">


               <v-card>
                  <v-layout wrap>
                     <v-flex md12>
                        <v-text-field
                            v-model="screencast_url"
                            label="Screencast URL"
                            hint="URL must start with http://screencast.com/  (no 'www' in url)"
                        ></v-text-field>
                     </v-flex>


                     <v-flex md12
                             v-for="(value, i) in files"
                             :key="'file'+i"
                     >
                        <input type="file" ref="fileInputs" v-on:change="selectFile(i)" style="display:none"/>
                        <v-text-field
                            label="Select File To Upload"
                            v-model="files[i].name"
                            hint="select file"
                            @click="$refs.fileInputs[i].click()"
                            append-outer-icon="clear"
                            @click:append-outer="files.splice(i, 1)"
                        ></v-text-field>
                     </v-flex>

                     <v-flex xs8 sm10 md10></v-flex>
                     <v-flex grow></v-flex>
                     <v-flex shrink>
                        Add another file?
                        <v-icon v-on:click="files.push({file: null, name:''})">add</v-icon>
                     </v-flex>


                     <!----- edit file ------------------>
                     <div v-if="isEditMode" class="pl-2 pr-2 pb-3">
                        <div style="font-size: 12pt; font-weight: 600; padding-bottom: 0px">
                           Previously uploaded files
                        </div>
                        <div md12
                             v-for="(value, i) in existing_files"
                             style="font-size: 12pt"
                             :key="'oldfile-'+ i"
                        >
                     <span v-if="value.filename !=null">
                     {{ value.filename }}
                     </span>
                           <span v-else>
                     Screenshot {{ i + 1 }}:
                     </span>

                           <v-btn icon small @click="download_file(value.file_id, value.filename)">
                              <v-icon color="primary">cloud_download</v-icon>
                           </v-btn>

                           <!--<v-btn icon small @click="show_delete_file_prompt(value.file_id, i)">-->
                           <v-btn icon small @click="existing_files.splice(i, 1)">
                              <v-icon color="red">delete</v-icon>
                           </v-btn>
                        </div>
                     </div>


                  </v-layout>
                  <!--<v-card-actions>-->
                  <!--<v-spacer></v-spacer>-->
                  <!--<v-btn slot="append-outer" v-on:click="submitFile()">-->
                  <!--Upload File-->
                  <!--</v-btn>-->
                  <!--</v-card-actions>-->

               </v-card>

               <v-layout md12 v-if="form_error_3" class="pb-0">
                  <v-flex grow></v-flex>
                  <v-flex shrink class="red--text">{{ form_error_3 }}</v-flex>
               </v-layout>

               <v-layout v-if="!isEditMode">
                  <v-btn color="primary" @click="stepper_step = 2">Go Back</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" :loading="submit_upload_files" @click="upload_files">
                     Upload Files and Continue
                     <!--<span v-if="saved_data.file_ids === null">Upload Files and Continue</span>-->
                     <!--<span v-else>Upload Files and Continue</span>-->
                  </v-btn>
               </v-layout>

               <v-layout v-else style="justify-content: center">


                  <v-btn color="primary" :loading="submit_upload_files" @click="upload_files">
                     Save Changes/Upload Files
                  </v-btn>
               </v-layout>


            </v-stepper-content>


            <!-----------------------------step 4 select recipients and email---------------------------------------------->
            <v-stepper-step step="4" :editable="isEditMode">Email Results and Finish</v-stepper-step>
            <v-stepper-content step="4">

               <v-card>
                  <v-layout wrap>
                     <v-flex xs12 pb-2>
                        This grade report for <span style="font-weight: bold;">{{ form.sales_people[0].name }}</span>
                        will be sent to
                        <span v-for="item in form.sales_people" :key="item.email">
                  {{ item.name }} ({{ item.email }}).
                </span> <br>
                        The following individuals will also be copied on this email.
                     </v-flex>

                     <v-flex xs12>
                        <span class="myheader">Client Users</span>
                        <ul style="list-style-type:none">
                           <li
                               v-for="(value, i) in managers"
                               :key="i"
                           >
                              <v-checkbox class="mt-0"
                                          :label="`${value.name} (${value.title}, ${value.email})`"
                                          v-model="value.include"
                                          hide-details
                              ></v-checkbox>
                           </li>
                        </ul>

                        <div class="myheader pt-3">Agency Users</div>
                        <ul style="list-style-type:none">
                           <li
                               v-for="(value, i) in agency_admins"
                               :key="i"
                           >
                              <v-checkbox class="mt-0"
                                          :label="`${value.name} (${value.role}, ${value.email})`"
                                          v-model="value.include"
                                          hide-details
                                          :readonly="canChangeEmailList"
                              ></v-checkbox>

                           </li>
                        </ul>

                        <div xs12 v-if="form.comments_internal !== ''">
                           <div class="myheader pt-3">Agency Users Who will be sent internal comments</div>
                           <ul style="list-style-type:none">
                              <li
                                  v-for="(value, i) in agency_admins_IC"
                                  :key="i"
                              >
                                 <v-checkbox class="mt-0"
                                             :label="`${value.name} (${value.role}, ${value.email})`"
                                             v-model="value.include"
                                             hide-details
                                             :readonly="canChangeEmailList"
                                 ></v-checkbox>

                              </li>
                           </ul>

                        </div>
                     </v-flex>

                     <v-flex xs12 pb-4></v-flex>

                  </v-layout>
               </v-card>


               <v-layout md12 v-if="form_error_4" class="pb-0">
                  <v-flex grow></v-flex>
                  <v-flex shrink class="red--text">{{ form_error_4 }}</v-flex>
               </v-layout>


               <v-layout v-if="!isEditMode">
                  <!--<v-btn color="primary" @click="stepper_step = 3">Go Back</v-btn>-->
                  <v-spacer></v-spacer>
                  <v-btn color="primary" :loading="submit_email_users" @click="send_emails2">Send Email and Finish
                  </v-btn>
               </v-layout>


               <v-layout v-else>
                  <!--<v-btn color="primary" @click="stepper_step = 3">Go Back</v-btn>-->
                  <v-spacer></v-spacer>
                  <v-btn color="primary" :loading="submit_email_users" @click="send_emails2">
                     <template v-if="edit_grade && edit_grade.emailed_users === null">
                        Send Email
                     </template>
                     <template v-else>
                        Re-Send Email
                     </template>
                  </v-btn>
                  <v-spacer></v-spacer>
               </v-layout>

            </v-stepper-content>


         </v-stepper>
      </v-container><!--end of stepper-->


   </div>
</template>


<style scoped>
.myheader {
    font-size: large;
    font-weight: bold;
    color: grey;
}

.myquestion {
    font-size: medium;
    padding-right: 5px;
}

.myforminput {
    /*padding-top: 5px;*/
    /*padding-bottom: 5px;*/
    padding-left: 10px;
    padding-right: 10px;

}

</style>


<script>
import states_data from '@/data/states.js';
import validate from '@/mixins/validation';
import data_getters from '@/mixins/data_getters';
import curricula_common from './curricula_common.js';
import formLeadInfo from './formLeadInfo'
import formCurriculum from "@/views/Curricula/formCurriculum";

// import axios from 'axios';
import {DateTime} from 'luxon';
import _ from "lodash";
import axios from "axios";
//
// import _ from 'lodash';
// const axios2  = axios.create({
//    timeout: 1000*60*5, //5 mins
// });

// function findWithAttr(array, attr, value) {
//    for(var i = 0; i < array.length; i += 1) {
//       if(array[i][attr] === value) {
//          return i;
//       }
//    }
//    return -1;
// }

let clean_form = {
   answers: {}, //object indexed by the index position in this.questions. e.g. answers[0] is the answer to this.questions[0]
   sales_people: [{user_id: '', name: '', email: ''}],
   info_cust: {name_first: '', name_last: '', address: '', city: '', state: '', zip: '', phone: '', email: ''},
   info_lead: {
      wanted_vehicle: '',
      lead_source: '',
      lead_arrived_date: null,
      lead_arrived_time: null,
      email_response_date: null,
      email_response_time: null,
      phone_response_date: null,
      phone_response_time: null,
      no_email_received: false,
      no_call_received: false
   },
   comments_internal: '',
   comments_external: '',
   date_grading_started: null,

};


export default {
   name: "GradeISM",
   mixins: [data_getters, validate, curricula_common],
   components: {formLeadInfo, formCurriculum},
   props: {
      grade_id: {type: String, default: null},

      // grade_id: {type: String, default: '60060e5556395f637d38ec4b'},
      // grade_id: {type: String, default: '5e0babaac68bfe0ef7873f4a'},
      // grade_id: {type: String, default: '60359fdd81078e57303001c5'},


   },
   data() {
      return {

         stepper_step: 1,
         form_error_1: null, //select user
         form_error_2: null, //main grading
         form_error_3: null, //upload files
         form_error_4: null, // email users


         files: [{name: '', file: null}],
         managers: [],
         form: JSON.parse(JSON.stringify(clean_form)),
         clean_form: JSON.parse(JSON.stringify(clean_form)),

         agency_admins: [],  //people to copy on email
         agency_admins_IC: [], //people to email if internal comments are written

         screencast_url: '',
         grade_score: 0,
         grade_letter: '',

         states: states_data,
         form_error: '',

         // // date/time picker state variables (used to toggle display state)
         // date_menu1: false,
         // date_menu2: false,
         // date_menu3: false,
         //
         // time_menu1: false,
         // time_menu2: false,
         // time_menu3: false,
         // lock_user: false,
         // picker_nudge: 30,

         submit_save_form: false,
         submit_upload_files: false,
         submit_email_users: false,


         //dealership/sales person data
         dealerships: [], //note set by get_dealers_local() in mixin
         selected_dealer_id: null,
         selectedDealership: null,
         salesPeople: [],
         selectedSalesPerson: null,
         curriculum: null,
         showpass: false,

         saved_data: {
            form_id: null, //objectid of the saved graded lead
            file_ids: null,
         },

         duplicate_lead_obj: {}, // used to save lead info to check for duplicates
         msg_duplicate_warning: null,
         lead_duplicates: [],


         //*** variables related to editing a grade ************
         existing_files: [], //used to hold current files when in edit mode
         edit_grade: null, //used to hold existing grade to edit

         show_cant_edit: false,
         edit_error_msg: null,
         edit_warning_msg: null,

         show_delete_file: false,
         file_to_del: null,//


         //******page headers****************************
         page: {
            title: "Grade ISM",
            // headline: "Black Page",
            // description: `A blank page is good to quick-start from scratch.`
         },

      };
   },

   computed: {
      computedDateFormatted() {
         return this.formatDate(this.date)
      },

      canChangeEmailList() {
         return !(this.$auth.profile.acct_type === 'AGENCY' && this.$auth.profile.user_role === 'Admin');
      },

      isEditMode() {
         if (this.$auth.profile.acct_type === 'AGENCY'
             // && this.$auth.profile.user_role === 'Admin'
         ) {
            return (this.grade_id != null && typeof this.grade_id === 'string');
         } else {
            return false;
         }

      },

      editing_error() {
         return (this.isEditMode && this.edit_error_msg != null);
      }

   },

   watch: {
      editing_error(newVal) {
         this.show_cant_edit = newVal;
      }
   },


   methods: {

      stepper_1() {
         if (!this.$refs.form_1.validate()) {
            this.form_error_1 = 'Please check highlighted fields.';
            return;
         }

         this.stepper_step = 2;
         this.form_error_1 = null;
         this.form.date_grading_started = new Date();
      },


      async on_user_change(i){

         let ix = this.findWithAttr(this.salesPeople, 'user_id', this.form.sales_people[i].user_id);
         this.form.sales_people[i].name =  this.salesPeople[ix].name;
         this.form.sales_people[i].email =  this.salesPeople[ix].email;

         //select curriculum based on first salesperson selected
         if (i===0){
            this.selectedSalesPerson = this.form.sales_people[i].user_id;
            await this.get_users_curriculum();

         }

      },

      async get_agency_people() {

         // initiate calls for admin users, (wait for the calls to finish later)
         let admins_p = this.get_users({acct_type: 'AGENCY', include_on_grades: true, is_active:true});//gets both Admins and AcctMangers
         let admins_internal_p = this.get_users({acct_type: 'AGENCY', include_on_IC: true, is_active:true});


         //add admins/acctManagers
         this.agency_admins = [];
         this.agency_admins_IC = [];

         //TODO: this is slightly inefficient if agency_admins_IC resolves first
         let data1 = await admins_p;
         for (let i = 0; i < data1.length; i++) {
            this.agency_admins.push({
               name: data1[i].name, email: data1[i].email,
               include: data1[i].app_metadata.include_on_grades,
               role: data1[i].app_metadata.role,
               app_metadata: data1[i].app_metadata,
            })
         }

         let data2 = await admins_internal_p;
         for (let i = 0; i < data2.length; i++) {
            this.agency_admins_IC.push({
               name: data2[i].name, email: data2[i].email,
               include: data2[i].app_metadata.include_on_grades,
               role: data2[i].app_metadata.role,
               app_metadata: data1[i].app_metadata,
            })
         }

      },


      on_first_comment_activate() {
         console.log('debug')
         if (this.form.comments_external == null || this.form.comments_external === '') {
            this.form.comments_external = this.get_comments_first_paragraph();
         }
      },

      get_comments_first_paragraph() {
         let date_in, time_in, email_date, email_time, call_date, call_time;

         if (this.curriculum.email_template === 'PHONE') {
            return;
         }

         // console.log('debug')


         date_in = DateTime.fromISO(this.form.info_lead.lead_arrived_date).toFormat('L/d/yyyy');
         time_in = DateTime.fromISO(this.form.info_lead.lead_arrived_time).toFormat('h:mma');
         email_date = DateTime.fromISO(this.form.info_lead.email_response_date).toFormat('L/d/yyyy');
         email_time = DateTime.fromISO(this.form.info_lead.email_response_time).toFormat('h:mma');

         call_date = DateTime.fromISO(this.form.info_lead.phone_response_date).toFormat('L/d/yyyy');
         call_time = DateTime.fromISO(this.form.info_lead.phone_response_time).toFormat('h:mma');

         // let d;
         let ans = `The lead was received ${date_in} at ${time_in}. `;

         if (this.form.info_lead.no_email_received) {
            ans += `No email address was provided`

            if (this.form.info_lead.no_call_received) {
               ans += `. No phone number was provided. `
            } else {
               ans += `. The first phone call was made ${call_date} at ${call_time}. `;
            }

         } else {
            ans += `The first personal email was sent ${email_date} at ${email_time}`;

            if (this.form.info_lead.no_call_received) {
               ans += `. No phone number was provided. `;

            } else {
               ans += ` and the first phone call was made `;
               if (call_date != email_date) {
                  ans += `on ${call_date} `
               }
               ans += `at ${call_time}. `
            }

         }

         let num_calls = null, num_texts = null, num_days = '??';
         let ix = this.findWithAttr(this.curriculum.questions, 'q_id.q_num', 21);

         let skip_texts = false;

         if (ix > -1) {
            let ix_a = this.form.answers[ix];
            if (ix_a != null) {
               num_calls = this.curriculum.questions[ix].q_id.answers[ix_a].ans;

               let num_calls2 = num_calls.split(' ')[0];

               if (num_calls2.includes('-1')) {
                  ans += `There were no calls or texts (due to no phone number provided) `
                  skip_texts = true;
               } else {

                  if (num_calls2 === '1')
                     ans += `There was ${num_calls.toLowerCase()} call `
                  else
                     ans += `There were ${num_calls.toLowerCase()} calls `
               }


            }
         }


         ix = this.findWithAttr(this.curriculum.questions, 'q_id.q_num', 131);
         if (ix > -1 && !skip_texts) {
            let ix_a = this.form.answers[ix];
            if (ix_a != null) {
               num_texts = this.curriculum.questions[ix].q_id.answers[ix_a].ans;


               if (num_texts.toLowerCase().includes('no')) {
                  'and no texts'
               } else {
                  ans += `and ${num_texts.toLowerCase()} text`

                  if (num_texts !== '1')
                     ans += 's '
                  else
                     ans += ` `
               }

            }

         }

         // if (num_calls !== null && num_texts !== null){
         //    num_calls_texts = Number(num_calls) + Number(num_texts);
         // }


         ix = this.findWithAttr(this.curriculum.questions, 'q_id.q_num', 22);
         if (ix > -1) {
            let ix_a = this.form.answers[ix];
            if (ix_a != null)
               num_days = this.curriculum.questions[ix].q_id.answers[ix_a].ans;

         }
         ans += `in ${num_days} days. `

         return ans;
      },




//**************************************************************************

      /**
       * updated send_email function where most of the logic of processing is moved to the backend
       * @return
       */
      async send_emails2(){


         this.submit_email_users = true;

         //TODO: Currently assumes only sending to first sales person in list
         let email_list = [];
         let email_cc = [];

         let emailed_users = [];


         // add sales people
         let list = this.form.sales_people;
         for (let i=0; i<list.length; i++) {
            email_list.push(list[i].email);

            emailed_users.push({
               email: list[i].email,
               name: list[i].name,
               user_id:  list[i].user_id,
               type: 'to'
            });
         }

         //add managers
         list = this.managers;
         for (let i=0; i<list.length; i++){
            if (list[i].include){
               email_cc.push(list[i].email);

               emailed_users.push({
                  email: list[i].email,
                  name: list[i].name,
                  user_id:  list[i].user_id,
                  type: 'to'
               });
            }

         }




         //******************get agency people***************************************

         //add the person grading
         email_cc.push(this.$auth.profile.email);

         //add admins/acctManagers

         list = this.agency_admins;
         for (let i=0; i<list.length; i++){
            if (list[i].include){
               email_cc.push(list[i].email);

               emailed_users.push({
                  email: list[i].email,
                  name: list[i].name,
                  user_id:  list[i].user_id,
                  type: 'cc'
               });
            }

         }


         // console.log('val', admins)
         console.log(email_list);
         console.log(email_cc);

         let link = process.env.VUE_APP_BASE_URL + `/view-grade/${this.saved_data.form_id}`;
         let file_link = process.env.VUE_APP_BASE_URL + `/download-file/${this.saved_data.form_id}`;
         let file_links  =[];
         for (let i in this.saved_data.file_ids ){
            file_links.push(file_link+'?file_ix='+i)
         }

         let email_data = {
            to: email_list,
            cc: email_cc,
            name: this.form.sales_people[0].name,
            vehicle: this.form.info_lead.wanted_vehicle,
            customer: this.form.info_cust.name_first + ' ' + this.form.info_cust.name_last,
            grade: this.grade_letter,
            lead_date_in: this.form.info_lead.lead_arrived_date,
            link: link,
            vlink: this.screencast_url,
            file_links: file_links,
            comments_external: this.form.comments_external
         };

         let email_body = {
            agency_id: this.$auth.profile.agency_id,
            email_data: email_data,
            email_template:  this.curriculum.email_template
         };





         //check if there are internal comments.  Email agency admins separately.
         let ic_email_data = null;
         if (this.form.comments_internal !== '' ){

            let email_IC = []; //this.agency_admins_IC.map(x => x.email);

            for (let i=0; i<this.agency_admins_IC.length; i++){
               if (this.agency_admins_IC[i].include)
                  email_IC.push(this.agency_admins_IC[i].email)
            }


            ic_email_data = {
               to: email_IC,
               name: this.form.sales_people[0].name,
               vehicle: this.form.info_lead.wanted_vehicle,
               customer: this.form.info_cust.name_first + ' ' + this.form.info_cust.name_last,
               grade: this.grade_letter,
               link: link,
               comments_internal: this.form.comments_internal,

            };

            let url_IC = this.$baseUrlApi + '/sendEmailInternalComments';
            // await axios.post(url_IC, {email_data: email_data}, token);
         }



         // *** define grade update data after emailed************************************
         let grade_update = {
            grade_id: this.saved_data.form_id,
            emailed_users
         };


         // let token = await this.$auth.getAxiosHeader();
         let {token} = await this.base_user_request();
         let url = this.$baseUrlApi + '/finalizeGradedLead';



         console.log('email data', email_data);
         try {




            let post_data = {
               agency_id: this.$auth.profile.agency_id,
               email_data: email_body,
               IC_email_data: ic_email_data,
               grade_update: grade_update
            };

            await axios.post(url,post_data , token);






            //********clear out data*************************************


            this.form = JSON.parse(JSON.stringify(clean_form));
            this.selectedSalesPerson = null;
            this.curriculum = null;
            this.stepper_step = 1;
            this.files = [{name:'', file:null}];
            this.saved_data = {form_id: null, file_ids: null};
            this.screencast_url = '';


            this.form_error_1 = null;
            this.form_error_2 = null;
            this.form_error_3 = null;
            this.$refs.form_1.resetValidation();
            this.$refs.form_2.resetValidation();



            this.$emit('close');







         }
         catch(err) {
            this.form_error_4  = this.show_error_details(err, 'send_emails()');
            // this.form_error_4 = "There was an issues sending email.  Please contact tech support."
         }


         this.submit_email_users = false;
      },




      async save_form(){

         if (!this.$refs.form_2.validate()){
            this.form_error_2 = 'Please check highlighted fields.';
            return;
         }

         this.submit_save_form = true;

         const grades = ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D+', 'D', 'D-', 'F'];
         this.form_error = null;

         let dealer_ix = this.findWithAttr(this.dealerships, '_id', this.selected_dealer_id);
         let post_data = {
            grade_score: this.grade_score, // raw score ism got 0 ... 100
            grade_letter: this.grade_letter,
            grade_letter_ix: grades.indexOf(this.grade_letter), //convert letter grade to number for easier analytics later
            date_grading_started: this.form.date_grading_started,
            info_grader: {
               name: this.$auth.profile.name,
               email: this.$auth.profile.email,
               user_id:  this.$auth.profile.sub
            },
            info_customer: this.form.info_cust,
            info_lead: this.form.info_lead,

            sales_people: this.form.sales_people,
            curriculum: {id: this.curriculum._id, name:this.curriculum.name},
            dealership:{
               id: this.selected_dealer_id,
               name: this.dealerships[dealer_ix].name
            },
            organization: {
               id: this.dealerships[dealer_ix].org_id._id,
               name: this.dealerships[dealer_ix].org_id.name
            },
            questions: [], //objects {question, answer, score, weight}
            comments_internal: this.form.comments_internal,
            comments_external:this.form.comments_external,
            agency_id: this.$auth.profile.agency_id,
         };


         if (this.saved_data.form_id != null){
            post_data._id = this.saved_data.form_id;
         }

         // get data for curriculum questions
         let questions = this.curriculum.questions;
         for (let i=0; i<questions.length; i++){
            let ans_ix = this.form.answers[i];
            if (ans_ix !== undefined){
               post_data.questions.push({
                  question_id: questions[i].q_id._id,
                  question: questions[i].q_id.question,
                  answer: questions[i].q_id.answers[ans_ix].ans,
                  score: questions[i].q_id.answers[ans_ix].score,
                  weight: questions[i].weight
               })
            }
            else{
               this.form_error = "Please answer all curriculum questions.";
               break;
            }

         }


         console.log(post_data);

         //save to db
         if (!this.form_error){
            try {
               let token = await this.$auth.getAxiosHeader();
               let url = this.$baseUrlApi + '/saveGradedLead';
               var res = await axios.post(url, post_data, token);
               this.saved_data.form_id = res.data; //returns id of saved doc


               if (!this.isEditMode){
                  this.stepper_step = 3;
               }


            }
            catch(err){
               this.form_error_2 = this.show_error_details(err, 'save_form()');
               // this.form_error_2 = 'There was an error saving.  Please contact tech support.'


            }
         }

         setTimeout(()=>{
            this.submit_save_form = false;
         }, 200)



      },



      //*******************functions for edit mode ***********************************************************
      // function to populate form with data from an existing graded lead***********
      async edit_existing_grade(grade_id){

         let grade = await this.get_graded_leads({_id: grade_id});

         if (grade.length !== 1){
            throw Error('Grade not found')
         }
         //assumes length can't be greater than 1

         this.form = _.cloneDeep(this.clean_form); //note, assuming this defined in the consuming component

         grade = grade[0];

         this.edit_grade = grade;
         this.saved_data.form_id = grade._id;
         this.existing_files =  grade.additional_data.files;


         console.log({grade});
         this.selected_dealer_id = grade.dealership.id;
         await this.on_select_dealership();

         this.salesPeople  = grade.sales_people

         this.form.sales_people = grade.sales_people;
         // await this.on_user_change(0);

         //todo: need to pull the curriculum stored in the grade


         await this.get_users_curriculum(grade.curriculum.id);
         // this.stepper_1(false);

         this.form.info_cust = {
            name_first: grade.info_customer.name_first,
            name_last: grade.info_customer.name_last,

         }
         this.form.info_lead = grade.info_lead;



         //****** recreate answers object for form *******
         let answers = {};
         let questions_map = {};//used to create hash map of questions by id

         for (let q of this.curriculum.questions){
            questions_map[q.q_id._id] = q.q_id;
         }

         console.log('debug')
         let ix, q_id, ans, ans_list,q;

         let questions_matched = 0;//used to count how many question in grade match up with those in the curriculum
         for (let i=0; i<grade.questions.length; i++){

            ans = grade.questions[i].answer
            q_id = grade.questions[i].question_id;


            q = questions_map[q_id];

            if (q == null){
               this.edit_error_msg = `Couldn't find question ${i+1} in current version of the curriculum.  `;
               throw Error(`couldn't find graded question id=${q_id} in current version curriculum`);
            }
            else{
               questions_matched += 1;
            }

            ans_list = q.answers;

            ix = this.findWithAttr(ans_list, 'ans', ans);
            if (ix > -1){
               answers[i] = ix;
            }else{
               console.log(`Ans="${ans}" not found in question "${q.question}"`)
            }

         }

         this.form.answers = answers;

         if (questions_matched < this.curriculum.questions.length ){
            this.edit_warning_msg = `New questions have been added to the curriculum since this lead was originally graded.`;
         }

         this.$refs.form_curriculum.grade_form(0);




         //*** add in comments ********

         this.form.comments_external = grade.comments_external;
         this.form.comments_internal = grade.comments_internal;

         if (this.form.comments_internal===null){
            this.form.comments_internal = '';
         }


         // ** get files/links********

         let url = _.get(grade, 'additional_data.info_urls', []);
         if (url.length===1){
            url = url[0];
         }
         else{
            url = '';
         }

         this.screencast_url = url;
      },













   }, //methods
   //******************************************************************************************************************


   async created() {
      await this.get_dealers_local();
      this.get_agency_people().then();

      if (this.grade_id != null) {
         this.edit_existing_grade(this.grade_id);
         return;
      }


      // get url query parameters
      if (this.$route.query.dealer_id !== undefined) {
         this.selected_dealer_id = this.$route.query.dealer_id;
         await this.on_select_dealership();
         // await this.get_users_local();

         if (this.$route.query.user_id !== undefined) {
            this.form.sales_people[0].user_id = this.$route.query.user_id;
            this.on_user_change(0);
         }
      }

      // console.log('query params', this.$route.query);


   },


};
</script>
